import React, {useEffect, useMemo, useRef} from "react";
import {UserState, userStore} from "../../api/AuthService";
import {DriverProfile} from "../../api/model/DriverProfile";

const InboxMessageBox = (props: any) => {

    const {userInfo}: { userInfo: DriverProfile } = userStore((state: UserState) => ({userInfo: state.driver}));
    const endRef = useRef<HTMLDivElement>(null);

    const bubbles = useMemo(() => {
      return (props.msgArray || []).map((element: any, index: number) => {
        const isMine = element.isFromDriver !== undefined ? element.isFromDriver : element.from === userInfo.driverCode;
        const text = element.message !== undefined ? element.message : element.body;

        return (
          <div
            key={`${index}-${element.time || ''}-${String(text).slice(0, 24)}`}
            className={`inbox-bubble${isMine ? ' inbox-bubble--mine' : ' inbox-bubble--theirs'}`}
          >
            <div className="inbox-bubble__body">{text}</div>
            {element.time ? <div className="inbox-bubble__time">{element.time}</div> : null}
          </div>
        );
      });
    }, [props.msgArray, userInfo.driverCode])

    useEffect(() => {
      const id = window.setTimeout(() => {
        endRef.current?.scrollIntoView({behavior: 'smooth', block: 'end'});
      }, 120);
      return () => window.clearTimeout(id);
    }, [props.msgArray?.length]);

    return (
      <div className="inbox-thread">
        {bubbles}
        <div ref={endRef} className="inbox-thread__end" />
      </div>
    )
}
export default InboxMessageBox;
